import React from 'react';
import CircularTherapyTimer from './CircularTherapyTimer';

const FullscreenTimerModal = ({ 
  isOpen, 
  onClose, 
  currentSeconds, 
  goalSeconds, 
  variant = 'default' 
}) => {
  if (!isOpen) return null;

  const goalMinutes = Math.floor(goalSeconds / 60);

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'linear-gradient(135deg, #151A24 0%, #1D2333 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        animation: 'fadeIn 0.3s ease-out',
        cursor: 'pointer'
      }}
    >
      <div style={{ transform: 'scale(1.6)', marginBottom: '40px' }}>
        <CircularTherapyTimer
          currentSeconds={currentSeconds}
          goalSeconds={goalSeconds}
          variant={variant}
          onOpenFullscreen={null}
        />
      </div>

      <div style={{ 
        textAlign: 'center', 
        color: 'white',
        maxWidth: '400px',
        padding: '0 20px'
      }}>
        <p style={{ 
          fontSize: '18px', 
          fontWeight: 500, 
          marginBottom: '8px',
          opacity: 0.9
        }}>
          Votre session d'écoute est en cours
        </p>
        <p style={{ 
          fontSize: '14px', 
          opacity: 0.6 
        }}>
          Objectif du jour : {goalMinutes} minutes
        </p>
      </div>

      <button
        onClick={onClose}
        style={{
          marginTop: '40px',
          padding: '12px 32px',
          background: 'rgba(255,255,255,0.1)',
          border: '1px solid rgba(255,255,255,0.2)',
          borderRadius: '24px',
          color: 'white',
          fontSize: '14px',
          fontWeight: 500,
          cursor: 'pointer',
          backdropFilter: 'blur(10px)',
          transition: 'all 0.2s'
        }}
        onMouseEnter={(e) => {
          e.target.style.background = 'rgba(255,255,255,0.15)';
          e.target.style.borderColor = 'rgba(255,255,255,0.3)';
        }}
        onMouseLeave={(e) => {
          e.target.style.background = 'rgba(255,255,255,0.1)';
          e.target.style.borderColor = 'rgba(255,255,255,0.2)';
        }}
      >
        Fermer
      </button>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default FullscreenTimerModal;
